import React from 'react';
import { RulesProvider } from './RulesContext';

interface ExternalMatchRequestRulesWrapperProps {
  children: React.ReactNode;
}

const ExternalMatchRequestRulesWrapper: React.FC<ExternalMatchRequestRulesWrapperProps> = ({
  children,
}) => {
  return <RulesProvider>{children}</RulesProvider>;
};

export default ExternalMatchRequestRulesWrapper;

